var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.windowWidth > 1263)?_c('div',{class:{
      videos: true,
      'videos-wrapper-skeleton-loader': _vm.isSkeletonLoader,
    }},[_vm._t("default")],2):_c('DragScroll',{attrs:{"itemsToShow":4.5,"isSkeletonLoader":_vm.isSkeletonLoader}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }